import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

interface VisitorAnalyticsFullResponse {
    meta: {
        error: boolean;
        code: number;
        message: string;
    };
    data: {
        overview: {
            total_visitors: number;
            unique_visitors: number;
            engagement_rate: number;
            mobile_percentage: number;
            desktop_percentage: number;
            tablet_percentage: number;
            proactive_engagement_rate: number;
        };
        conversations: {
            new_customers: number;
            returning_customers: number;
            total_conversations: number;
            new_customer_percentage: number;
            returning_customer_percentage: number;
        };
        engagement: {
            total_sessions: number;
            engaged_sessions: number;
            engagement_rate: number;
            proactive_shown: number;
            proactive_accepted: number;
            proactive_engagement_rate: number;
        };
        device_split: {
            mobile: number;
            desktop: number;
            tablet: number;
            other: number;
            mobile_percentage: number;
            desktop_percentage: number;
            tablet_percentage: number;
            other_percentage: number;
        };
    };
}

export const getVisitorAnalyticsFull = async (storeId: string) => {
    try {
        const response = await Axios.get(`/visitor_analytics/${storeId}/full`);
        return response.data as VisitorAnalyticsFullResponse;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetVisitorAnalyticsFull = (storeId: string) => {
    const analytics = useQuery({
        queryKey: ["get-visitor-analytics-full", storeId],
        queryFn: () => getVisitorAnalyticsFull(storeId),
        enabled: !!storeId,
    });

    return analytics;
};